import { useCallback } from "react";
import { useSetAtom } from "jotai/react";

import { LanguageType } from "@libs/i18n";
import { pendingLanguageAtom } from "@/stores/atoms";
import { useCurrentUserAuthId } from "@/stores/authStore";

import { useAppLanguage } from "./useAppLanguage";

// Persist the pending choice before setLanguage restarts the app.
export const useUpdatePreferredLanguage = () => {
  const { setLanguage } = useAppLanguage();
  const setPendingLanguage = useSetAtom(pendingLanguageAtom);
  const currentUserAuthId = useCurrentUserAuthId();

  const updatePreferredLanguage = useCallback(
    (locale: LanguageType) => {
      setPendingLanguage({ language: locale, authUserId: currentUserAuthId });
      setLanguage(locale);
    },
    [currentUserAuthId, setLanguage, setPendingLanguage],
  );

  return { updatePreferredLanguage };
};
